import React, { FC, useState } from 'react';
import { Cancel } from '@mui/icons-material';
import { Dialog, IconButton, Table, TableCell, TableRow } from '@mui/material';
import { toast } from 'react-toastify';
import API from 'api/API';
import Button from 'components/Button';
// import DropDown from 'components/DropDown/DropDown';
import InputField from 'components/InputField';
import { useLanguage } from 'context/AppContext';
import * as Styles from './AddSerialNumberModal.styles';

type EditSerialNumberModalProps = {
  open: boolean;
  close: () => void;
  setUUID: string | null;
  setSerialId: string;
  serialNumberInitial: string;
};

const EditSerialNumberModal: FC<EditSerialNumberModalProps> = ({
  open,
  close,
  setUUID,
  setSerialId,
  serialNumberInitial,
}) => {
  const [language] = useLanguage();
  const [serialNumber, setSerialNumber] = useState(serialNumberInitial);

  const handleConfirm = async (): Promise<void> => {
    try {
      await API.UssEndpoint.editSerialNumber(setSerialId, { set_code: setUUID || '', new_uss: serialNumber });
      toast.success(language.ManageSerialNumbers.Modal.updated);
    } catch (error) {
      API.errorHandler(error);
    }
    setSerialNumber('');
    close();
  };

  return (
    <Dialog open={open} onClose={close} maxWidth={'lg'} fullWidth={false}>
      <Styles.Container>
        <IconButton sx={{ position: 'absolute', top: '1rem', right: '1rem' }} onClick={close}>
          <Cancel />
        </IconButton>
        <h2 style={{ textAlign: 'left', paddingLeft: '15px' }}>{language.ManageSerialNumbers.Modal.editTitle}</h2>
        <Table>
          <TableRow>
            <TableCell>
              <Styles.Message>{language.ManageSerialNumbers.Modal.enterUniqueSerialNumber}</Styles.Message>
            </TableCell>
            <TableCell>
              <InputField
                type="text"
                variant="outlined"
                fullWidth
                value={serialNumber}
                onChange={e => setSerialNumber(e.target.value)}
              />
            </TableCell>
          </TableRow>
        </Table>

        <Button onClick={handleConfirm} style={{ position: 'absolute', bottom: '1rem', right: '1rem' }}>
          {language.ManageSerialNumbers.Modal.submit}
        </Button>
        <Button onClick={() => close()} style={{ position: 'absolute', bottom: '1rem', left: '1rem' }}>
          {language.ManageSerialNumbers.Modal.cancel}
        </Button>
      </Styles.Container>
    </Dialog>
  );
};

export default EditSerialNumberModal;
